export const SET_CHECKED_SHOW_BUTTON_ZERO = "SET_CHECKED_SHOW_BUTTON_ZERO";
export const SET_DATE_DISPLAY_FORMAT = 'SET_DATE_DISPLAY_FORMAT'